__turbopack_context__.v({
  "graftableToggle": "QuickOptions-module-scss-module__3vOPWW__graftableToggle",
  "graftableToggleHint": "QuickOptions-module-scss-module__3vOPWW__graftableToggleHint",
  "quickOptions": "QuickOptions-module-scss-module__3vOPWW__quickOptions",
  "typeLabel": "QuickOptions-module-scss-module__3vOPWW__typeLabel",
});
